// Environment variables available during frontend build
// Not available in cloudflare workers (not through this interface at least)
export const ZERO_SERVER_URL = import.meta.env.PUBLIC_ZERO_SERVER_URL;
export const DURABLE_OBJECT_HOST = import.meta.env.PUBLIC_DURABLE_OBJECT_HOST;
export const AUTH_SERVER_URL = import.meta.env.PUBLIC_AUTH_SERVER_URL;
export const IS_PRODUCTION = import.meta.env.MODE === "production";
export const MAPBOX_TOKEN = import.meta.env.PUBLIC_MAPBOX_TOKEN;
